module.exports = __webpack_public_path__ + "static/media/allen.c89a4092.png";